import {PANELMANAGER_HIDE_CONFIRMCLOSEDIALOG} from '../../constants';

export type HideConfirmCloseDialogAction = {
    type : typeof PANELMANAGER_HIDE_CONFIRMCLOSEDIALOG;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {HideConfirmCloseDialogAction}
 */
export default function hideConfirmCloseDialog( panelKey : string ) : HideConfirmCloseDialogAction {
    return {
        type: PANELMANAGER_HIDE_CONFIRMCLOSEDIALOG,
        panelKey
    };
}
